// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27uba","rootMobile":"styles_rootMobile__2z_hZ"};